<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block">Scenarios</h1>
  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray" (click)="showinfo = !showinfo"></i>

  <!-- <button class="btn btn-primary" (click)="showScenarioIdModalNew = true" style="float: right;margin-top:10px;margin-left:10px">Add Scenario</button> -->
  <button class="btn btn-info" (click)="hideAllScenarios()" style="float: right;margin-top:10px;margin-left:10px">Hide Version 1 Scenarios</button>
  <button class="btn btn-info" (click)="showAllScenarios()" style="float: right;margin-top:10px;margin-left:10px">Show All Scenarios</button>
  <div style="float: right;margin-top:10px;margin-left:10px;display:inline-flex;gap:4px">
    <input class="form-control form-control-sm" style="width:200px" [(ngModel)]="componentSearch" placeholder="Component name/file..." (keyup.enter)="searchByComponent()" />
    <button class="btn btn-secondary btn-sm" (click)="searchByComponent()">Search</button>
  </div>
  <div style="float: right;margin-top:10px;margin-left:10px;display:inline-flex;gap:4px">
    <input class="form-control form-control-sm" style="width:200px" [(ngModel)]="interactivityClassSearch" placeholder="Interactivity class..." (keyup.enter)="searchByInteractivityClass()" />
    <button class="btn btn-secondary btn-sm" (click)="searchByInteractivityClass()">Search</button>
  </div>

  <br>
  <div *ngIf="showinfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    A <b>scenario</b> describes a specific situation or environment which is simulated. It defines a list of lesson steps
    together with interactivities around a specific topic.
    <br><br>
    <b>Note:</b> An Exercise is the execution of a scenario. It is associated with a teacher, students, and date/time.
    <br><br>
    <b>Dev Note:</b> The property "isVersion2" is used to distinguish between the old and new scenarios.
  </div>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Id = Property Name <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(scenarios,'id',sortArray)"></i></th>
        <th style="min-width:100px">SeqNo <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(scenarios,'seqNo',sortArray)"></i></th>
        <th>Edit</th>
        <th>Duplicate</th>
        <th>Display Name <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(scenarios,'name',sortArray)"></i></th>
        <th>Status</th>
        <th style="max-width:200px">Description</th>
        <th>isVersion2</th>
        <th>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let e of scenarios" [ngClass]="{'dev-scenario': e.seqNo >= 100, 'interactivity-match': scenariosWithClass.has(e.id), 'component-match': scenariosWithComponent.has(e.id)}">
        <td>{{e.id}}</td>
        <td>{{e.seqNo}}</td>
        <td><i class="bi bi-pencil" style="color:green" (click)="edit(e)"></i></td>
        <td><i class="bi bi-clipboard-plus" style="color:rgb(0, 9, 128)" (click)="duplicateModalOpen(e)"></i></td>
        <td>{{e.displayName}}</td>
        <td>{{e.status}}</td>
        <td style="max-width:200px">
          {{ e._expanded ? e.description : (e.description | slice:0:60) }}{{ !e._expanded && (e.description?.length > 60) ? '...' : '' }}
          <button *ngIf="e.description?.length > 60" class="btn btn-link btn-sm p-0 ms-1" (click)="e._expanded = !e._expanded">
            {{ e._expanded ? 'Less' : 'More' }}
          </button>
        </td>
        <td>{{e.isVersion2}}</td>
        <td><i class="bi bi-trash" style="color:orange" (click)="remove(e)"></i></td>
      </tr>
    </tbody>
  </table>
</div>

<!---  Modal to new ScenarioId -------------------------------------------------------------->
<div *ngIf="showScenarioIdModal" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">
      Duplicate Scenario
    </div>

    <div class="spacer10"></div>
    <div><sa-input-text [(text)]="newScenarioName" [title]="'Name' "></sa-input-text></div>
    <button class="btn btn-primary" (click)="saveDuplicateScenario()">Create Duplicate</button>
    <button class="btn btn-primary" style="float:right" (click)="showScenarioIdModal = false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>
<!---  Modal to new ScenarioId -------------------------------------------------------------->
<div *ngIf="showScenarioIdModalNew" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">
      Create New Scenario
    </div>

    <div class="spacer10"></div>
    <div><sa-input-text [(text)]="newScenarioName" [title]="'Name' "></sa-input-text></div>
    <button class="btn btn-primary" (click)="createNewScenario()">Create Scenario</button>
    <button class="btn btn-primary" style="float:right" (click)="showScenarioIdModalNew = false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>

<!---  Modal verify delete -------------------------------------------------------------->
<div *ngIf="showScenarioDeleteModal" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">
      Delete Scenario
    </div>

    <div class="spacer10"></div>
    <div>Do you really want to delete the scenario {{newScenarioName}}</div>
    <button class="btn btn-primary" (click)="confirmDeleteScenario()">Confirm</button><br>
    <button class="btn btn-primary" style="float:right" (click)="showScenarioDeleteModal = false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>